import { register } from "@shopify/theme-sections";
import Swiper from "swiper/bundle";

register("featured-collections", {
  initCarousel(el) {
    if (!el) return;
    const swiper = new Swiper(el, {
      loop: false,
      slidesPerView: 4,
      spaceBetween: 15,
      navigation: {
        nextEl: el.querySelector(".swiper-button-next"),
        prevEl: el.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        100: {
          slidesPerView: 1.09,
        },
        500: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 4,
          allowTouchMove: false,
        },
      },
    });
  },

  initTabs() {
    const tabs = this.container.querySelectorAll("[data-tab-target]");
    const tabContents = this.container.querySelectorAll("[data-tab-content]");
    const tabCarousels = this.container.querySelectorAll(
      ".featured-collections__carousel"
    );

    tabCarousels.forEach((carousel) => {
      this.initCarousel(carousel);
    });

    let tabsWidth = 0;
    tabs.forEach((tab) => {
      tabsWidth += tab.clientWidth;
      tab.addEventListener("click", (e) => {
        const target = this.container.querySelector(
          `.featured-collections__tabs [data-tab-id='${e.currentTarget.dataset.tabId}']`
        );
        tabContents.forEach((tabContent) => {
          tabContent.classList.remove("active");
        });
        tabs.forEach((tab) => {
          tab.classList.remove("active");
        });
        tab.classList.add("active");
        target.classList.add("active");
      });
    });
    if (tabsWidth > window.outerWidth && window.outerWidth < 992) {
      this.container.querySelector(
        ".featured-collections__tab-links ul"
      ).style.justifyContent = "flex-start";
    }
  },

  onLoad: function (e) {
    this.initTabs();
  },
});
